import React from "react";

// * STYLES
import "./b-footer.scss";

export default (props) => {
  const b = "b-footer";
  return <footer className={`${b} js-footer`}></footer>;
};
